<template>
    <div v-if="openModal">
        <form action="#" @submit.prevent="submitButton">
            <div ></div>
            <div class="modal-co">
                <div class="header-modal content-modal-folder">
                    <h4 class="modal-h4">{{ data.title }}</h4>
                </div>
                <div class="content-modal content-modal-folder ">
                    <svg class="folder-modal" id="FolderRepresentation" data-name="FolderRepresentation"
                    xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 64 64">
                    <path class="st0" d="M6,59c-2.8,0-5-2.2-5-5V10c0-2.8,2.2-5,5-5h20.2c1.1,0,2.1,0.4,2.8,1.2l6.2,6.2c0.4,0.4,0.9,0.6,1.4,0.6H58
                    c2.8,0,5,2.2,5,5v36c0,2.8-2.2,5-5,5H6z"></path>
                    <path class="st1" d="M58,12H36.7c-0.3,0-0.5-0.1-0.7-0.3l-6.2-6.2c-1-1-2.2-1.5-3.5-1.5H6c-3.3,0-6,2.7-6,6v44c0,3.3,2.7,6,6,6h52
                    c3.3,0,6-2.7,6-6V18C64,14.7,61.3,12,58,12z M62,54c0,2.2-1.8,4-4,4H6c-2.2,0-4-1.8-4-4V14h56c2.2,0,4,1.8,4,4V54z"></path>
                </svg>
                <input type="text" class="modal-input" placeholder="folder name" v-model="newTitle" @keyup.enter="submitButton">
                <!-- <span class="error-modal-input-icon"><i class="fa fa-exclamation-triangle"
                    aria-hidden="true"></i></span> -->
                    <!-- <span class="error-modal-input">Name is exists</span> -->

                </div>
                <div class="footer-modal text-right">
                    <span class="model-cancel" @click="cancelCreateFolderModal">Cancel</span>
                    <button v-if="!itemEdit" class="success-button active-success-button" type="submit" >Готово</button>
                    <button v-else class="success-button active-success-button" type="submit" >Готово1</button>

                </div>
            </div>
        </form>
    </div>
</template>


<script>

    import axios from 'axios'

    export default {
        name: 'create-folder',
        data(){
            return {
                data: {
                    title: 'Create folder'
                },
                newTitle: '',
                idForItem: 4,
                openModal: false,
                path: '',
                // createFolder: true,
                itemEdit: false
            }
        },

        created() {
            eventBus.$on('openModalCreateFolder', (data) => {
                this.openModal = data.openModal
                this.path = data.path

                if(!data.item) {
                } else {
                    this.data.title = 'Edit folder'
                    this.itemEdit = data.item
                    console.log(this.itemEdit)
                    this.newTitle = data.item.title
                   // this.editFolder(data.item)
               }

           })
        },

        beforeDestroy() {
           eventBus.$off('openModalCreateFolder')
       },

       methods: {
        submitButton() {
            // this.itemEdit ? this.createFolder() : this.editFolder()
            if(this.itemEdit == false) {
                this.createFolder()
            } else {

                this.editFolder()

                this.itemEdit = false
                this.newTitle = ''
                this.path = ''

            }
            this.openModal = false
        },
        createFolder() {
            if(this.newTitle.trim().length == 0) {
                return
            }
            axios.post(this.$store.getters.getMainDomainName+'files', {
                title: this.newTitle,
                path: this.path,

            })
            .then(response => {
                console.log(response.data)
                this.data.title = 'Create folder'
                
                this.$emit('addItemBottomFile', response.data)

                
            })
           
            .catch(error => {this.$emit('addItemBottomFile', 'false')})

            this.newTitle = '',
            this.idForItem++

        },

        editFolder() {

         axios.patch(this.$store.getters.getMainDomainName+'system/files/'+this.itemEdit.id, {
            id: this.itemEdit.id,
            path: this.itemEdit.path,
            icon: this.itemEdit.icon,
            oldTitle: this.itemEdit.title,
            title: this.newTitle,
            type: this.itemEdit.type,

        })
         .then(response => {
             console.log(response.data)

             this.$emit('finishedEditFile', response.data)

             return

            // state.items.push({
            //     id: response.data.id,
            //     title: response.data.title,
            //     type: response.data.type,
            //     icon: response.data.icon,
            //     path: response.data.path,
            //     checked: false,
            // })
        })
         .catch(error => {this.$emit('finishedEditFile', 'false')})
     },
     cancelCreateFolderModal() {
         this.openModal = false
     }
 }

}

</script>

<style scoped src="../../assets/css/modals/folder.css"></style>




// WEBPACK FOOTER //
// src/components/app_modules/ModalCreateFolder.vue